import React, { useState } from "react";

/**
 * Public coin icon CDNs, tried in order. The phone loads them directly
 * (never through our backend) and sends no referrer. Same sources as the
 * ticker picker.
 */
const COIN_LOGO_SOURCES = [
  (base: string) =>
    `https://icon.gateimg.com/images/coin_icon/64/${base.toLowerCase()}.png`,
  (base: string) => `https://bin.bnbstatic.com/static/assets/logos/${base}.png`,
];

/** `NEARUSDT` -> `NEAR`, `1000PEPEUSDT` -> `PEPE`. */
export function coinLogoBase(symbol: string): string {
  return symbol
    .toUpperCase()
    .replace(/[-_/:]/g, "")
    .replace(/(USDT|USDC|USD)(PERP|M)?$/, "")
    .replace(/^10{2,}(?=[A-Z])/, "");
}

export const CoinLogo: React.FC<{ symbol: string; className?: string }> = ({
  symbol,
  className = "h-6 w-6",
}) => {
  const coin = coinLogoBase(symbol);
  const [source, setSource] = useState(0);
  if (source >= COIN_LOGO_SOURCES.length) {
    return (
      <div
        className={`flex shrink-0 items-center justify-center rounded-full bg-white/10 text-[10px] font-semibold text-text-secondary ${className}`}
      >
        {coin.slice(0, 2)}
      </div>
    );
  }
  return (
    <img
      key={coin}
      src={COIN_LOGO_SOURCES[source](coin)}
      alt=""
      referrerPolicy="no-referrer"
      onError={() => setSource((index) => index + 1)}
      className={`shrink-0 rounded-full bg-white/5 ${className}`}
    />
  );
};
